import { useState } from "react";
import { toast } from "sonner";
import { Facebook, Twitter, MessageCircle, Copy, Check } from "lucide-react";
import { shareFacebook, shareTwitter, shareWhatsApp } from "@/lib/share";

export function ShareButtons({ url, quote, showCopy = true }) {
  const [copied, setCopied] = useState(false);

  const copy = async () => {
    try {
      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(url);
      } else {
        const ta = document.createElement("textarea");
        ta.value = url; ta.style.position = "fixed"; ta.style.opacity = "0";
        document.body.appendChild(ta); ta.select();
        document.execCommand("copy"); document.body.removeChild(ta);
      }
      setCopied(true);
      toast.success("Link copied!");
      setTimeout(() => setCopied(false), 2000);
    } catch { toast.error("Copy failed"); }
  };

  return (
    <div data-testid="share-buttons" className="flex items-center gap-2">
      <button
        data-testid="share-facebook"
        onClick={() => shareFacebook(url, quote)}
        className="flex-1 flex items-center justify-center gap-2 py-2.5 rounded-full bg-[#1877F2] hover:bg-[#1564cf] text-white font-semibold text-sm transition-colors">
        <Facebook size={16} /> Share on Facebook
      </button>
      <button
        data-testid="share-whatsapp"
        onClick={() => shareWhatsApp(url, quote)}
        title="Share on WhatsApp"
        className="w-10 h-10 shrink-0 rounded-full grid place-items-center bg-[#25D366]/15 border border-[#25D366]/40 text-[#25D366] hover:bg-[#25D366]/25 transition-colors">
        <MessageCircle size={16} />
      </button>
      <button
        data-testid="share-twitter"
        onClick={() => shareTwitter(url, quote)}
        title="Share on X"
        className="w-10 h-10 shrink-0 rounded-full grid place-items-center bg-white/5 border border-white/15 text-[#F9FAFB] hover:bg-white/10 transition-colors">
        <Twitter size={16} />
      </button>
      {showCopy && (
        <button
          data-testid="share-copy"
          onClick={copy}
          title="Copy link"
          className="w-10 h-10 shrink-0 rounded-full grid place-items-center bg-[#F59E0B] text-black hover:bg-[#d98c08] transition-colors">
          {copied ? <Check size={16} /> : <Copy size={16} />}
        </button>
      )}
    </div>
  );
}
